import { MiddleOfficeButtonType } from '@shared/components/button-middle-office/enums';

export const iframeUrlMiddleOffice: Record<Exclude<keyof typeof MiddleOfficeButtonType, 'DISCONNECT'>, string> = {
  EDIT_HERO: 'hero',
  EDIT_SCHEDULES: 'hours',
  EDIT_REALISATION: 'realisation/manage',
  EDIT_TEAMS: 'teams',
  ADD_REALISATION: 'realisation/create',
};
